import { IColorRGB } from "Model/IQuiltRenderData";

export class ImageDataHelper {
    public static fill(image: ImageData, color: IColorRGB) {
        for (let y = 0; y < image.height; ++y) {
            for (let x = 0; x < image.width; ++x) {
                const index = (y * image.width * 4) + (x * 4);

                image.data[index] = color.r;
                image.data[index + 1] = color.g;
                image.data[index + 2] = color.b;
                image.data[index + 3] = 255;
            }
        }
    }

    public static drawCellSquare(image: ImageData, cellSize: number, cellX: number, cellY: number, color: IColorRGB) {
        const yBaseOffset = cellY * cellSize;
        const xBaseOffset = cellX * cellSize;
    
        for (let pixelY = 0; pixelY < cellSize; ++pixelY) {
            const yOffset = (yBaseOffset + pixelY) * image.width * 4;
    
            for (let pixelX = 0; pixelX < cellSize; ++pixelX) {
                const offset = yOffset + ((xBaseOffset + pixelX) * 4);
    
                image.data[offset] = color.r;
                image.data[offset + 1] = color.g;
                image.data[offset + 2] = color.b;
                image.data[offset + 3] = 255;
            }
        }
    }
    
    public static  drawCellTriangleNE(image: ImageData, cellSize: number, cellX: number, cellY: number, color: IColorRGB) {
        const yBaseOffset = cellY * cellSize;
        const xBaseOffset = cellX * cellSize;
    
        for (let pixelY = 0; pixelY < cellSize; ++pixelY) {
            const yOffset = (yBaseOffset + pixelY) * image.width * 4;
    
            for (let pixelX = 0; pixelX < cellSize; ++pixelX) {
                if (pixelX < pixelY)
                {
                    continue;
                }
    
                const offset = yOffset + ((xBaseOffset + pixelX) * 4);
    
                image.data[offset] = color.r;
                image.data[offset + 1] = color.g;
                image.data[offset + 2] = color.b;
                image.data[offset + 3] = 255;
            }
        }
    }
    
    public static  drawCellTriangleNW(image: ImageData, cellSize: number, cellX: number, cellY: number, color: IColorRGB) {
        const yBaseOffset = cellY * cellSize;
        const xBaseOffset = cellX * cellSize;
    
        for (let pixelY = 0; pixelY < cellSize; ++pixelY) {
            const yOffset = (yBaseOffset + pixelY) * image.width * 4;
    
            for (let pixelX = 0; pixelX < cellSize; ++pixelX) {
                if (pixelX > cellSize - pixelY - 1)
                {
                    continue;
                }
    
                const offset = yOffset + ((xBaseOffset + pixelX) * 4);
    
                image.data[offset] = color.r;
                image.data[offset + 1] = color.g;
                image.data[offset + 2] = color.b;
                image.data[offset + 3] = 255;
            }
        }
    }
    
    public static  drawCellTriangleSE(image: ImageData, cellSize: number, cellX: number, cellY: number, color: IColorRGB) {
        const yBaseOffset = cellY * cellSize;
        const xBaseOffset = cellX * cellSize;
    
        for (let pixelY = 0; pixelY < cellSize; ++pixelY) {
            const yOffset = (yBaseOffset + pixelY) * image.width * 4;
    
            for (let pixelX = 0; pixelX < cellSize; ++pixelX) {
                if (pixelX < cellSize - pixelY - 1)
                {
                    continue;
                }
    
                const offset = yOffset + ((xBaseOffset + pixelX) * 4);
    
                image.data[offset] = color.r;
                image.data[offset + 1] = color.g;
                image.data[offset + 2] = color.b;
                image.data[offset + 3] = 255;
            }
        }
    }
    
    public static  drawCellTriangleSW(image: ImageData, cellSize: number, cellX: number, cellY: number, color: IColorRGB) {
        const yBaseOffset = cellY * cellSize;
        const xBaseOffset = cellX * cellSize;
    
        for (let pixelY = 0; pixelY < cellSize; ++pixelY) {
            const yOffset = (yBaseOffset + pixelY) * image.width * 4;
    
            for (let pixelX = 0; pixelX < cellSize; ++pixelX) {
                if (pixelX > pixelY)
                {
                    continue;
                }
    
                const offset = yOffset + ((xBaseOffset + pixelX) * 4);
    
                image.data[offset] = color.r;
                image.data[offset + 1] = color.g;
                image.data[offset + 2] = color.b;
                image.data[offset + 3] = 255;
            }
        }
    }
}